import { render, staticRenderFns } from "./CreateCampaignFaqItem.vue?vue&type=template&id=9723bb7e&scoped=true"
import script from "./CreateCampaignFaqItem.vue?vue&type=script&lang=js"
export * from "./CreateCampaignFaqItem.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignFaqItem.vue?vue&type=style&index=0&id=9723bb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9723bb7e",
  null
  
)

export default component.exports